import z from "zod"
import { Errors } from "../../errors"

export const UpsertZendeskIntegrationSchema = z.object({
  companySubdomain: z.string().min(1, { message: Errors.ZENDESK_COMPANY_SUBDOMAIN_REQUIRED }),
  token: z.string().min(1, { message: Errors.ZENDESK_TOKEN_REQUIRED }),
  email: z.string().min(1, { message: Errors.EMAIL_REQUIRED }),
})
